// Safe localStorage JSON helpers
export function parseJSONSafe(str) {
  if (str === null || str === undefined) return null;
  // If it's already an object, just return it
  if (typeof str === 'object') return str;
  if (typeof str !== 'string') return null;
  const trimmed = str.trim();
  if (trimmed === '' || trimmed === 'undefined' || trimmed === 'null') return null;
  try {
    return JSON.parse(str);
  } catch (e) {
    // invalid JSON
    return null;
  }
}

export function getItemJSON(key) {
  try {
    return parseJSONSafe(sessionStorage.getItem(key));
  } catch (e) {
    return null;
  }
}

export function setItemJSON(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error('Error setting session storage:', e);
  }
}

export function removeItem(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.error('Error removing session storage:', e);
  }
}

export function clearAllSession() {
  try {
    sessionStorage.clear();
  } catch (e) {
    console.error('Error clearing session storage:', e);
  }
}
